import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import {RoutesStorage} from '@helpers/routes.helper';

export class WorkingObjectListItem {
    id: number;
    viewUrl: string;

    constructor(
        private _rawData: WorkingObjectNamespace.ListItem
    ) {
        this.setAttributes();
    }

    get rawData(): WorkingObjectNamespace.ListItem {
        return this._rawData;
    }

    private setAttributes() {
        this.id = this.rawData.id;
        this.viewUrl = RoutesStorage.WorkingObject.view(this.id);
    }
}
